export default "__VITE_ASSET__e90da0ac__"